import { api } from 'services/api';

import { PriceSpecificity } from './types';

type UpdatePriceDetailsParams = {
  budgetId: number;
  compositionId: number;
  priceId: number;
  priceTypeId: number;
  localeId: number;
  description?: string;
  shouldUpdateDescription?: boolean;
  currentCustomDescription?: string | null;
  priceSpecificities: PriceSpecificity[];
};

export const updatePriceDetails = async ({
  budgetId,
  compositionId,
  priceId,
  priceTypeId,
  localeId,
  description,
  shouldUpdateDescription = false,
  currentCustomDescription = null,
  priceSpecificities,
}: UpdatePriceDetailsParams): Promise<void> => {
  const payload: {
    price_type_id: number;
    locale_id: number;
    custom_description: string | null;
    price_specificity: PriceSpecificity[];
  } = {
    price_type_id: priceTypeId,
    locale_id: localeId,
    custom_description: shouldUpdateDescription
      ? (description ?? null)
      : currentCustomDescription,
    price_specificity: priceSpecificities,
  };

  await api.put(
    `budget/${budgetId}/composition/${compositionId}/price/${priceId}`,
    payload,
  );
};
